import React, { useContext } from "react";
import { Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { BasicContext } from "../../App";
import moment from "moment";
import { postMethod } from "../../requests";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";

const SignUpForClassBtns = (props) => {
    const { t } = useTranslation();
    const { changeView, setAlerts, checkServerData } = useContext(BasicContext);
    const { c, j, disableBtn, setDisableBtn, permissions } = props;

    const checkIfUserBlocked = async () => {
        const res = await postMethod("/check-if-user-blocked");
        if (checkServerData(res)) {
            if (!permissions.signInClass) {
                setTimeout(() => {
                    setAlerts([{ variant: "danger", message: t("error.dontHavePerrmisionForSigningUp"), id: `noPermissionAlert${j}` }]);
                    setDisableBtn(false);
                }, 400);
            } else if (res.data.userBlocked) {
                setTimeout(() => {
                    setAlerts([
                        {
                            variant: "warning",
                            message: (
                                <>
                                    <FontAwesomeIcon icon={faExclamationTriangle} className="me-2" />
                                    {t("warning.userIsBlocked")}
                                </>
                            ),
                            id: `userBlocked${j}`,
                            fading: 3000,
                        },
                    ]);
                    setDisableBtn(false);
                }, 400);
            } else {
                changeView({ nav: "schedule", sub: "signUpForClass", params: { class: c } });
                setAlerts([]);
            }
        }
    };

    const allowSigning = () => {
        setDisableBtn(true);
        setAlerts([{ variant: "info", message: t("info.checkingConditions") }]);
        checkIfUserBlocked();
    };

    return (
        <>
            {c.canUserSignIn && (
                <>
                    {moment().format() > moment(c.class_signup_end_time).format() || moment().format() < moment(c.class_signup_start_time).format() ? (
                        <span className="d-block text-center opacity-75">{t("classes.signupClosed")}</span>
                    ) : c.free_slots > 0 ? (
                        <Button size="sm" disabled={disableBtn} className={`btn-class btn-${c.class_level_colour}`} onClick={() => allowSigning()}>
                            {t("classes.signIn")}
                        </Button>
                    ) : (
                        <Button
                            size="sm"
                            disabled={disableBtn}
                            className={`btn-class btn-outline-${c.class_level_colour}`}
                            onClick={() => {
                                setDisableBtn(true);
                                setAlerts([{ variant: "info", message: t("info.checkingConditions") }]);
                                if (permissions.signInClass) {
                                    changeView({ nav: "schedule", sub: "signUpForWaitingList", params: { class: c } });
                                    setAlerts([]);
                                } else {
                                    setTimeout(() => {
                                        setAlerts([{ variant: "danger", message: t("error.dontHavePerrmisionForBooking"), id: `noPermissionAlert${j}` }]);
                                        setDisableBtn(false);
                                    }, 400);
                                }
                            }}
                        >
                            {t("classes.book")}
                        </Button>
                    )}
                </>
            )}
        </>
    );
};

export default SignUpForClassBtns;
